import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--cream)', fontFamily: 'DM Sans, sans-serif', color: 'var(--text-dark)' }}>
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '48px 24px 80px' }}>

        <div style={{ marginBottom: 40 }}>
          <Link to="/login" style={{ color: 'var(--sage)', textDecoration: 'none', fontSize: 14 }}>← Back to login</Link>
        </div>

        <h1 style={{ fontFamily: 'Lora, serif', fontSize: 32, fontWeight: 700, marginBottom: 8, color: 'var(--text-dark)' }}>
          Privacy Policy
        </h1>
        <p style={{ color: 'var(--text-soft)', fontSize: 14, marginBottom: 40 }}>Last updated: May 15, 2026</p>

        <Section title="Overview">
          <p>Transformation Companion ("we," "our," or "us") is a practice management tool for coaches and practitioners. This Privacy Policy explains how we collect, use, and protect information when you use our web application at app.transformationcompanion.com.</p>
          <p>By using Transformation Companion, you agree to the practices described in this policy.</p>
        </Section>

        <Section title="Information We Collect">
          <Subsection title="Coach Account Information">
            <p>When you create an account, we collect your name, email address, and practice details including your modality and practice type.</p>
          </Subsection>
          <Subsection title="Client Information">
            <p>Coaches enter information about their clients, including names, session history, goals, background notes, and psychological profiles ("avatars") generated by AI. This information is stored on your behalf and is only accessible to you.</p>
          </Subsection>
          <Subsection title="Session Data">
            <p>Session transcripts, AI-generated summaries, breakthrough quotes, and session goals are stored in your account. Transcripts may be pasted in manually or imported automatically via Zoom cloud recordings.</p>
          </Subsection>
          <Subsection title="Voice Messages">
            <p>If you or your clients exchange voice messages through the platform, audio files are stored in Supabase Storage and transcribed using AssemblyAI.</p>
          </Subsection>
          <Subsection title="Usage Data">
            <p>We collect standard server logs including IP addresses, browser type, and pages accessed. This data is used for debugging and service improvement.</p>
          </Subsection>
        </Section>

        <Section title="How We Use Your Information">
          <ul style={{ paddingLeft: 20, lineHeight: 2 }}>
            <li>To provide and operate the Transformation Companion service</li>
            <li>To generate AI-powered session summaries and client insights using Anthropic Claude</li>
            <li>To transcribe voice messages using AssemblyAI</li>
            <li>To send you email notifications about new Zoom recordings and account activity via Resend</li>
            <li>To sync Zoom cloud recordings to your account when you have connected Zoom</li>
            <li>To improve the service and diagnose technical issues</li>
          </ul>
          <p>We do not sell your data to third parties. We do not use client session data to train AI models.</p>
        </Section>

        <Section title="Third-Party Services">
          <p>Transformation Companion uses the following third-party services to operate:</p>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14, marginTop: 12 }}>
            <thead>
              <tr style={{ borderBottom: '2px solid var(--border, #ddd)' }}>
                <th style={{ textAlign: 'left', padding: '8px 12px 8px 0', color: 'var(--text-mid)' }}>Service</th>
                <th style={{ textAlign: 'left', padding: '8px 12px 8px 0', color: 'var(--text-mid)' }}>Purpose</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Supabase', 'Database, authentication, and file storage'],
                ['Anthropic Claude', 'AI-generated session summaries and client insights'],
                ['AssemblyAI', 'Voice message transcription'],
                ['Zoom', 'Cloud recording imports via webhook'],
                ['Resend', 'Email notifications'],
                ['Vercel', 'Frontend web hosting'],
                ['Railway', 'Backend API hosting'],
              ].map(([service, purpose]) => (
                <tr key={service} style={{ borderBottom: '1px solid var(--border-light, #eee)' }}>
                  <td style={{ padding: '10px 12px 10px 0', fontWeight: 600 }}>{service}</td>
                  <td style={{ padding: '10px 12px 10px 0', color: 'var(--text-mid)' }}>{purpose}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p style={{ marginTop: 16 }}>Each of these services has its own privacy policy governing their handling of data.</p>
        </Section>

        <Section title="HIPAA Notice">
          <div style={{ background: '#FFF8F0', border: '1px solid var(--gold)', borderRadius: 8, padding: '16px 20px' }}>
            <p style={{ margin: 0, color: 'var(--text-dark)' }}>
              <strong>Transformation Companion is not currently HIPAA-compliant.</strong> We do not have a Business Associate Agreement (BAA) in place with our infrastructure providers. Coaches who are covered entities or business associates under HIPAA should not use this platform to store protected health information (PHI) until HIPAA compliance is established.
            </p>
          </div>
        </Section>

        <Section title="Data Storage and Security">
          <p>All data is stored in Supabase (PostgreSQL) with row-level security enabled. Data is encrypted in transit using TLS. Access to your data is restricted to your account through Supabase's authentication system.</p>
          <p>Voice messages are stored in a private Supabase Storage bucket accessible only through authenticated API requests.</p>
          <p>While we take reasonable measures to protect your data, no system is completely secure. We recommend not storing sensitive identifying information beyond what is necessary for your coaching practice.</p>
        </Section>

        <Section title="Client Consent">
          <p>Coaches are responsible for obtaining appropriate consent from their clients before entering client information into Transformation Companion, including consent for AI processing of session transcripts. We provide the tools; the coach-client consent relationship is your responsibility.</p>
        </Section>

        <Section title="Data Retention">
          <p>Your data is retained as long as your account is active. You may delete client records, sessions, and messages at any time through the application. To delete your entire account and all associated data, contact us at the email below.</p>
        </Section>

        <Section title="Your Rights">
          <p>You may access, export, or request deletion of your data at any time. To exercise these rights, contact us at the email address below. We will respond within 30 days.</p>
        </Section>

        <Section title="Changes to This Policy">
          <p>We may update this Privacy Policy from time to time. We will notify registered coaches by email when material changes are made. Continued use of the service after changes constitutes acceptance of the updated policy.</p>
        </Section>

        <Section title="Contact">
          <p>Questions about this Privacy Policy or your data? Contact us at: <a href="mailto:stevo2012@gmail.com" style={{ color: 'var(--sage)' }}>stevo2012@gmail.com</a></p>
        </Section>

        <div style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid var(--border-light, #eee)', display: 'flex', gap: 24 }}>
          <Link to="/terms" style={{ color: 'var(--sage)', textDecoration: 'none', fontSize: 14 }}>Terms of Service</Link>
          <Link to="/login" style={{ color: 'var(--text-soft)', textDecoration: 'none', fontSize: 14 }}>Back to login</Link>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 36 }}>
      <h2 style={{ fontFamily: 'Lora, serif', fontSize: 20, fontWeight: 700, marginBottom: 12, color: 'var(--text-dark)' }}>{title}</h2>
      <div style={{ lineHeight: 1.75, color: 'var(--text-mid)', fontSize: 15 }}>
        {children}
      </div>
    </div>
  );
}

function Subsection({ title, children }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <h3 style={{ fontFamily: 'DM Sans, sans-serif', fontSize: 15, fontWeight: 700, marginBottom: 4, color: 'var(--text-dark)' }}>{title}</h3>
      <div style={{ lineHeight: 1.75, color: 'var(--text-mid)', fontSize: 15 }}>
        {children}
      </div>
    </div>
  );
}
